import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../shared/services/auth.service';
import { UserService } from '../../shared/services/user.service';
import { GlobalVariable } from '../../shared/helpers/settings';
import { User } from '../../shared/models/user';
import { Language, LayoutService } from '../../shared/services/layout.service';
import { Role } from '../../shared/models/user-role';
import { ProjectService } from '../../shared/services/project.service';

@Component({
	selector: 'app-login',
	templateUrl: './login.component.html',
	styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
	@ViewChild('googleSignIn') googleSignInButton!: ElementRef;

	public globalUserInfo = GlobalVariable['CONNECTUSER'];
	public user: User = {
		username: null,
		email: null,
		firstName: null,
		roles: [],
		salary: null,
		lastName: null,
		phoneNumber: null,
		address: null,
		password: null,
		imageUrl: null,
		city: null,
		active: true,
		project: null
	};
	// public user: firebase.User;
	public loginForm: FormGroup;
	public show: boolean = false;
	public isError: boolean = false;
	public errorMessage: string;
	private returnRoute: string;
	public selectedLang: Language;
	public isButtonDisabled = false;

	constructor(
		private fb: FormBuilder,
		public router: Router,
		private authService: AuthService,
		private userService: UserService,
		private projectService: ProjectService,
		private activatedRoute: ActivatedRoute,
		private layoutService: LayoutService
	) {
		this.loginForm = this.fb.group({
			email: ['', [Validators.required]],
			password: ['', Validators.required]
		});
	}

	ngOnInit() {
		this.initReturnUrl();
		this.selectedLang = this.layoutService.getCurrentLanguage();
	}

	login() {
		this.isError = false;
		this.isButtonDisabled = true;
		this.user.email = this.loginForm.value['email']?.trim();
		this.user.username = this.loginForm.value['email']?.trim();
		this.user.password = this.loginForm.value['password'];
		this.authService.login(this.user).subscribe(
			res => {
				const user = res.user;
				const selectedProject = res.project ?? null;
				this.isButtonDisabled = false;
				const currentUserRole = user?.userRole?.role as Role;
				if (selectedProject) {
					this.projectService.setCurrentProject(selectedProject, false);
					this.returnRoute = '/front/dashboard/' + selectedProject?._id;
				}

				if (!this.returnRoute) {
					this.returnRoute = this.userService.getNavigationRouteUrlByRole(user?.roles[0], currentUserRole);
				}
				this.router.navigate([this.returnRoute]);
			},
			err => {
				this.isError = true;
				this.isButtonDisabled = false;
				if (err === 'Unauthorized') this.errorMessage = 'Invalid credentials';
				else this.errorMessage = err;
			}
		);
	}

	initReturnUrl() {
		this.activatedRoute.queryParams.subscribe(res => {
			{
				if (res?.returnUrl) this.returnRoute = res.returnUrl;
				this.checkLogin();
			}
		});
	}

	checkLogin() {
		const user = this.userService.getCurrentUserInfos();
		const currentUserRole = user?.userRole?.role as Role;
		if (user) {
			if (!this.returnRoute) {
				this.returnRoute = this.userService.getNavigationRouteUrlByRole(user.roles[0], currentUserRole);
			}
			this.router.navigate([this.returnRoute]);
		}
	}

	showPassword() {
		this.show = !this.show;
	}

	// Trigger the asl-google-signin-button click
	triggerGoogleSignIn(): void {
		const googleButton = this.googleSignInButton.nativeElement.querySelector('div[role="button"]');
		if (googleButton) {
			googleButton.click(); // Simulate a click on the asl-google-signin-button
		}
	}
}
